type IconProps = {
  width?: number
  height?: number
  className?: string
}

export const ShoppingBagMedium = ({ height = 20, width = 20, className }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5 1.66675L2.5 5.00008V16.6667C2.5 17.1088 2.67559 17.5327 2.98816 17.8453C3.30072 18.1578 3.72464 18.3334 4.16667 18.3334H15.8333C16.2754 18.3334 16.6993 18.1578 17.0118 17.8453C17.3244 17.5327 17.5 17.1088 17.5 16.6667V5.00008L15 1.66675H5Z"
      stroke="white"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.5 5H17.5" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13.3334 8.33325C13.3334 9.21731 12.9822 10.0652 12.357 10.6903C11.7319 11.3154 10.8841 11.6666 10 11.6666C9.11597 11.6666 8.26812 11.3154 7.643 10.6903C7.01788 10.0652 6.66669 9.21731 6.66669 8.33325"
      stroke="white"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Logout = ({ height = 24, width = 24 }: IconProps) => (
  <svg fill="none" height={height} width={width} xmlns="http://www.w3.org/2000/svg">
    <g clipRule="evenodd" fill="#000" fillRule="evenodd">
      <path d="M4.167 3.333a.833.833 0 0 0-.833.834v11.666a.833.833 0 0 0 .833.834H7.5a.833.833 0 0 1 0 1.666H4.167a2.5 2.5 0 0 1-2.5-2.5V4.167a2.5 2.5 0 0 1 2.5-2.5H7.5a.833.833 0 0 1 0 1.666zm8.577 1.911a.833.833 0 0 1 1.179 0l4.166 4.167a.833.833 0 0 1 0 1.178l-4.166 4.167a.833.833 0 1 1-1.179-1.179L16.321 10l-3.577-3.577a.833.833 0 0 1 0-1.179z" />
      <path d="M6.667 10c0-.46.373-.833.833-.833h10a.833.833 0 1 1 0 1.666h-10A.833.833 0 0 1 6.667 10z" />
    </g>
  </svg>
)

export const Hamburger = ({ height = 24, width = 24 }: IconProps) => (
  <svg fill="none" height={height} width={width} xmlns="http://www.w3.org/2000/svg">
    <g clipRule="evenodd" fill="#fff" fillRule="evenodd">
      <path d="M2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1zm0-6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1zm0 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1z" />
    </g>
  </svg>
)

export const ShoppingBagThin = ({ height = 49, width = 49 }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.25 4.0835L6.125 12.2502V40.8335C6.125 41.9165 6.55521 42.9551 7.32098 43.7208C8.08675 44.4866 9.12537 44.9168 10.2083 44.9168H38.7917C39.8746 44.9168 40.9132 44.4866 41.679 43.7208C42.4448 42.9551 42.875 41.9165 42.875 40.8335V12.2502L36.75 4.0835H12.25Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.125 12.25H42.875" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M32.6666 20.4165C32.6666 22.5824 31.8062 24.6597 30.2746 26.1912C28.7431 27.7228 26.6659 28.5832 24.4999 28.5832C22.334 28.5832 20.2568 27.7228 18.7252 26.1912C17.1937 24.6597 16.3333 22.5824 16.3333 20.4165"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ShoppingBag = ({ height = 24, width = 24 }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 6H21" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Help = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z"
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.06006 5.99989C6.21679 5.55434 6.52616 5.17863 6.93336 4.93931C7.34056 4.7 7.81932 4.61252 8.28484 4.69237C8.75036 4.77222 9.1726 5.01424 9.47678 5.37558C9.78095 5.73691 9.94743 6.19424 9.94672 6.66656C9.94672 7.99989 7.94672 8.66656 7.94672 8.66656"
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 11.3335H8.00667" stroke="#191919" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

interface AlertProps {
  type: 'error' | 'default' | 'warning'
}

const colors: Record<AlertProps['type'], string> = {
  error: '#F94343',
  default: '#000',
  warning: '#f1bb00',
}

export const Alert: React.FC<{
  type: AlertProps['type']
  height?: number
  width?: number
  strokeWidth?: number
  dataCy?: string
}> = ({ type, height = 24, width = 24, strokeWidth = 2, dataCy }) => {
  return (
    <svg
      width={width}
      height={height}
      data-cy={dataCy}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={colors[type]}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 8V12" stroke={colors[type]} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="16" r="1" fill={colors[type]} />
    </svg>
  )
}

export const CreditCard = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z"
      stroke="#191919"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1 10H23" stroke="#191919" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const TrashBin = () => (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.75">
      <path
        d="M7.39163e-10 3.76744V2.85174C0.0178571 2.52035 0.151786 2.24128 0.401786 2.01453C0.651786 1.78779 0.946429 1.67442 1.28571 1.67442H2.57143V1.25581C2.57143 0.906977 2.69643 0.610465 2.94643 0.366279C3.19643 0.122093 3.5 0 3.85714 0H8.14286C8.5 0 8.80357 0.122093 9.05357 0.366279C9.30357 0.610465 9.42857 0.906977 9.42857 1.25581V1.67442H10.7143C11.0536 1.67442 11.3482 1.78779 11.5982 2.01453C11.8482 2.24128 11.9821 2.52035 12 2.85174V3.76744C12 3.99419 11.9152 4.19041 11.7455 4.35611C11.5759 4.52181 11.375 4.60466 11.1429 4.60465V11.7209C11.1429 12.1919 10.9777 12.5887 10.6473 12.9113C10.317 13.234 9.91072 13.3954 9.42857 13.3953H2.57143C2.08929 13.3953 1.68303 13.234 1.35267 12.9113C1.02231 12.5887 0.857134 12.1919 0.857143 11.7209V4.60465C0.625 4.60465 0.424105 4.5218 0.254457 4.35611C0.08481 4.19042 -9.1427e-06 3.9942 7.39163e-10 3.76744ZM0.857143 3.76744H11.1429V2.93023C11.1429 2.80814 11.1027 2.70785 11.0223 2.62935C10.942 2.55086 10.8393 2.51161 10.7143 2.51161H1.2857C1.1607 2.51161 1.05802 2.55086 0.977658 2.62935C0.897296 2.70785 0.857115 2.80814 0.857115 2.93023L0.857143 3.76744ZM1.71429 11.7209C1.71429 11.9477 1.7991 12.1439 1.96874 12.3096C2.13838 12.4753 2.33928 12.5581 2.57143 12.5581H9.42857C9.66071 12.5581 9.86161 12.4753 10.0313 12.3096C10.2009 12.1439 10.2857 11.9477 10.2857 11.7209V4.60465H1.71429V11.7209ZM3.42857 1.67442H8.57143V1.25581C8.57143 1.13372 8.53125 1.03343 8.45089 0.954935C8.37053 0.876442 8.26784 0.837196 8.14284 0.837196H3.85713C3.73213 0.837196 3.62945 0.876442 3.54909 0.954935C3.46872 1.03343 3.42854 1.13372 3.42854 1.25581L3.42857 1.67442Z"
        fill="black"
      />
      <rect x="3.34888" y="5.58142" width="0.893023" height="6.13953" rx="0.446512" fill="black" />
      <rect x="5.5813" y="5.58142" width="0.893023" height="6.13953" rx="0.446512" fill="black" />
      <rect x="7.81396" y="5.58142" width="0.893023" height="6.13953" rx="0.446512" fill="black" />
    </g>
  </svg>
)

export const Visa = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="26" fill="none" viewBox="0 0 40 26">
    <path fill="#fff" d="M0 0h40v26H0z" />
    <path
      fill="#1434CB"
      d="m15.9 7.7-4.43 10.6h-2.9l-2.2-8.47c-.13-.52-.25-.71-.65-.93C5.05 8.55 3.96 8.2 3 8l.07-.32h4.67c.6 0 1.13.4 1.27 1.09l1.15 6.14 2.86-7.23h2.89Zm11.39 7.15c0-2.8-3.88-2.96-3.85-4.21 0-.38.37-.79 1.16-.9a5.2 5.2 0 0 1 2.71.48l.48-2.25a7.4 7.4 0 0 0-2.57-.47c-2.71 0-4.62 1.44-4.64 3.51-.02 1.53 1.36 2.38 2.4 2.9 1.08.51 1.44.85 1.43 1.31 0 .71-.85 1.03-1.64 1.04-1.39.02-2.19-.37-2.82-.67l-.5 2.33c.64.29 1.82.55 3.05.56 2.89 0 4.78-1.42 4.79-3.63Zm7.17 3.46H37L34.78 7.7h-2.34c-.53 0-.98.3-1.17.78l-4.12 9.84h2.88l.57-1.58h3.53l.33 1.58Zm-3.07-3.76 1.45-3.99.83 4H31.4ZM19.83 7.7l-2.27 10.62h-2.74L17.09 7.7h2.74Z"
    />
  </svg>
)

export const MasterCard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="26" viewBox="0 0 40 26">
    <path fill="#fff" d="M0 0h40v26H0z" />
    <path fill="#F06022" d="M16.13 19.29h7.74V6.7h-7.74v12.58z" />
    <path
      fill="#EA1D25"
      d="M16.93 13A7.93 7.93 0 0 1 20 6.71a8.02 8.02 0 0 0-10.65.65 7.96 7.96 0 0 0 0 11.28 8.02 8.02 0 0 0 10.65.65A8.02 8.02 0 0 1 16.93 13"
    />
    <path
      fill="#F79D1D"
      d="M33 13c0 2.12-.84 4.15-2.34 5.65a8.1 8.1 0 0 1-10.66.64A8.05 8.05 0 0 0 23.07 13 7.96 7.96 0 0 0 20 6.71a8.02 8.02 0 0 1 10.66.64A7.93 7.93 0 0 1 33 13"
    />
  </svg>
)

export const Amex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="26" viewBox="0 0 40 26">
    <path fill="#016FD0" d="M0 26h40V0H0v26z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M30.69 13.63v1.64h-4.17v1.14h4.07v1.64h-4.07v1.12h4.17v1.66l3.38-3.6-3.38-3.6zm-1.1-6.14-1.4-3.19h-4l-4.1 9.32h3.33v8.27l10.28.01 1.61-1.8 1.63 1.8H40v-2.63l-1.92-2.06L40 15.16v-2.59l-1.93.01V7.6l-1.81 4.98H34.5l-1.86-5v5h-4.2l-.6-1.46h-3.3l-.6 1.46h-2.22l3.23-7.27V5.3h2.55l3.19 7.21V5.3l3.1.01 1.6 4.47 1.62-4.48H40v-1h-3.77l-.85 2.39-.85-2.39h-4.94v3.19zm-5.06 6.11v7.27h6.16v-.01h2.54l2.1-2.32 2.12 2.32H40v-.1l-3.34-3.53L40 13.65v-.05h-2.52l-2.1 2.3-2.08-2.3h-8.77zm.7-4.11.96-2.31.97 2.31h-1.93z"
    />
  </svg>
)

export const JCB = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="26" fill="none" viewBox="0 0 40 26">
    <g clipPath="url(#a)">
      <path fill="#fff" d="M0 0h40v26H0V0Z" />
      <path fill="#fff" d="M36.6 20.66a5.22 5.22 0 0 1-5.22 5.22H3V5.22A5.22 5.22 0 0 1 8.22 0H36.6v20.66Z" />
      <path
        fill="url(#b)"
        d="M27.36 15.36h2.15l.27-.02a.96.96 0 0 0 .76-.96 1 1 0 0 0-.76-.97c-.06-.02-.19-.02-.27-.02h-2.15v1.97Z"
      />
      <path
        fill="url(#c)"
        d="M29.27 1.75a3.74 3.74 0 0 0-3.74 3.73v3.89h5.28c.12 0 .26 0 .37.02 1.19.06 2.07.67 2.07 1.74 0 .84-.6 1.56-1.7 1.7v.05c1.2.08 2.13.76 2.13 1.8 0 1.13-1.03 1.87-2.38 1.87h-5.8v7.6H31a3.74 3.74 0 0 0 3.73-3.74V1.75h-5.46Z"
      />
      <path
        fill="url(#d)"
        d="M30.27 11.38c0-.5-.35-.82-.76-.89l-.2-.02h-1.95v1.81h1.95c.06 0 .18 0 .2-.02a.87.87 0 0 0 .76-.88Z"
      />
      <path
        fill="url(#e)"
        d="M8.6 1.75a3.74 3.74 0 0 0-3.73 3.73v9.22a7.4 7.4 0 0 0 3.22.85c1.3 0 2-.78 2-1.85V9.34h3.2v4.34c0 1.68-1.05 3.06-4.6 3.06-2.16 0-3.84-.47-3.84-.47v7.86h5.48a3.74 3.74 0 0 0 3.74-3.74V1.75H8.6Z"
      />
      <path
        fill="url(#f)"
        d="M18.94 1.75a3.74 3.74 0 0 0-3.74 3.73v4.9c.94-.8 2.59-1.32 5.24-1.2 1.41.06 2.93.45 2.93.45v1.58a7.1 7.1 0 0 0-2.83-.82c-2.01-.14-3.23.84-3.23 2.57 0 1.74 1.22 2.73 3.23 2.57a7.46 7.46 0 0 0 2.83-.82v1.58s-1.5.39-2.93.45c-2.65.12-4.3-.4-5.24-1.2v8.63h5.48a3.74 3.74 0 0 0 3.74-3.74V1.75h-5.48Z"
      />
    </g>
    <defs>
      <linearGradient id="b" x1="25.52" x2="34.75" y1="14.38" y2="14.38" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#007940" />
        <stop offset=".23" stopColor="#00873F" />
        <stop offset=".74" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <linearGradient id="c" x1="25.52" x2="34.75" y1="12.94" y2="12.94" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#007940" />
        <stop offset=".23" stopColor="#00873F" />
        <stop offset=".74" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <linearGradient id="d" x1="25.52" x2="34.75" y1="11.37" y2="11.37" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#007940" />
        <stop offset=".23" stopColor="#00873F" />
        <stop offset=".74" stopColor="#40A737" />
        <stop offset="1" stopColor="#5CB531" />
      </linearGradient>
      <linearGradient id="e" x1="4.86" x2="14.24" y1="12.94" y2="12.94" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#1F286F" />
        <stop offset=".48" stopColor="#004E94" />
        <stop offset=".83" stopColor="#0066B1" />
        <stop offset="1" stopColor="#006FBC" />
      </linearGradient>
      <linearGradient id="f" x1="15.15" x2="24.25" y1="12.94" y2="12.94" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#6C2C2F" />
        <stop offset=".17" stopColor="#882730" />
        <stop offset=".57" stopColor="#BE1833" />
        <stop offset=".86" stopColor="#DC0436" />
        <stop offset="1" stopColor="#E60039" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h40v26H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const Lock = ({ height = 24, width = 24, className }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 24 24" width={width} className={className}>
    <g fill="none">
      <path d="M0 0h24v24H0V0z" />
      <path d="M0 0h24v24H0V0z" opacity=".87" />
    </g>
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" />
  </svg>
)

export const SupercellSLogo = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM18.1815 30.0927C19.4238 31.7452 20.7679 32.5714 22.2138 32.5714H26.8877C27.3357 32.5714 27.7125 32.5321 28.018 32.4534C28.3235 32.3747 28.6595 32.2075 29.0261 31.9518C29.3315 31.755 29.6879 31.46 30.0952 31.0665C30.5025 30.6731 30.8182 30.319 31.0422 30.0042C31.307 29.6501 31.4801 29.3255 31.5615 29.0304C31.643 28.7354 31.6837 28.3714 31.6837 27.9386V26.2567C31.6837 25.4895 31.4597 24.7813 31.0117 24.1321C30.5636 23.4829 29.9425 23.0501 29.1482 22.8337L21.389 20.7977C21.3687 20.7977 21.3483 20.7878 21.3279 20.7681C21.3076 20.7288 21.2974 20.6796 21.2974 20.6206V19.1157C21.2974 19.0567 21.4705 18.86 21.8167 18.5255C22.1629 18.1911 22.3666 18.0239 22.4277 18.0239H26.6739C27.2034 18.3583 27.7227 18.9681 28.2318 19.8534L31.7143 18.9681C31.4699 18.2993 31.1237 17.66 30.6757 17.0501C30.2072 16.4009 29.6268 15.8304 28.9344 15.3386C28.242 14.8272 27.4783 14.5714 26.6433 14.5714H22.3666C21.9185 14.5714 21.5418 14.6108 21.2363 14.6895C20.9308 14.7681 20.5948 14.9354 20.2282 15.1911C19.9227 15.3878 19.5663 15.6829 19.159 16.0763C18.7517 16.4698 18.4361 16.8239 18.212 17.1386C17.9473 17.4927 17.7742 17.8173 17.6927 18.1124C17.6113 18.4075 17.5705 18.7714 17.5705 19.2042V20.7386C17.5705 21.5059 17.7844 22.2141 18.212 22.8632C18.6601 23.5124 19.2914 23.9452 20.106 24.1616L27.8347 26.1681C27.8958 26.1878 27.9263 26.2468 27.9263 26.3452V28.0272C27.9263 28.0862 27.7532 28.2829 27.407 28.6173C27.0608 28.9518 26.8571 29.119 26.796 29.119H22.1833C21.6538 28.7845 21.1345 28.1747 20.6253 27.2895L17.1429 28.1747C17.4076 28.8829 17.7538 29.5222 18.1815 30.0927Z"
      fill="white"
    />
  </svg>
)

export const Globe: React.FC<{
  className?: string
  height?: number
  width?: number
}> = ({ className, height = 24, width = 24 }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 20.1668C16.0626 20.1668 20.1667 16.0628 20.1667 11.0002C20.1667 5.93755 16.0626 1.8335 11 1.8335C5.93738 1.8335 1.83333 5.93755 1.83333 11.0002C1.83333 16.0628 5.93738 20.1668 11 20.1668Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.83333 11H20.1667" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11 1.8335C13.2928 4.34365 14.5959 7.60119 14.6667 11.0002C14.5959 14.3991 13.2928 17.6567 11 20.1668C8.70715 17.6567 7.40414 14.3991 7.33333 11.0002C7.40414 7.60119 8.70715 4.34365 11 1.8335Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Pin: React.FC<{
  className?: string
  height?: number
  width?: number
}> = ({ className, height = 24, width = 24 }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M10.6084 1.06348C6.29681 1.06348 2.80151 4.55878 2.80151 8.87041C2.80151 10.7953 3.50132 12.5544 4.6562 13.9156L10.6084 20.9256L16.5605 13.9154C17.7154 12.5544 18.4152 10.7951 18.4152 8.87019C18.4154 4.55878 14.9201 1.06348 10.6084 1.06348ZM10.6084 11.8122C8.8352 11.8122 7.39784 10.3749 7.39784 8.60161C7.39784 6.82836 8.8352 5.391 10.6084 5.391C12.3817 5.391 13.8191 6.82836 13.8191 8.60161C13.8191 10.3749 12.3817 11.8122 10.6084 11.8122Z"
          fill="#D2D2D2"
        />
      </g>
    </svg>
  )
}
export const Cross = ({ height = 24, width = 24 }: IconProps) => (
  <svg fill="none" height={height} width={width} xmlns="http://www.w3.org/2000/svg">
    <g clipRule="evenodd" fillRule="evenodd">
      <path d="M18.707 5.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0z" />
      <path d="M5.293 5.293a1 1 0 0 1 1.414 0l12 12a1 1 0 0 1-1.414 1.414l-12-12a1 1 0 0 1 0-1.414z" />
    </g>
  </svg>
)

export const ArrowRight = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.5 6.25L11.1862 8.83109" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
    <path d="M11.2869 8.94995L7.60068 11.531" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
  </svg>
)

export const EditIcon: React.FC<IconProps> = ({ height = 24, width = 24 }) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4249 4.81802L4.58613 13.6549L1.5434 13.9914C0.661542 14.089 -0.0890433 13.3453 0.00856647 12.4569L0.345152 9.41479L9.18388 0.577961C9.95466 -0.192654 11.2 -0.192654 11.9674 0.577961L13.4215 2.0317C14.1923 2.80231 14.1923 4.05077 13.4249 4.81802ZM10.0994 5.85785L8.14383 3.90271L1.89008 10.1585L1.64437 12.3559L3.84227 12.1103L10.0994 5.85785ZM12.2805 3.17584L10.8264 1.7221C10.6884 1.58413 10.4629 1.58413 10.3283 1.7221L9.28822 2.76193L11.2438 4.71707L12.2838 3.67724C12.4185 3.53591 12.4185 3.31381 12.2805 3.17584Z"
      fill="black"
    />
  </svg>
)
